import Vue from 'vue'
import {mapGetters} from "vuex"

Vue.mixin({
  data() {
    return {
      imagePopup: false,
      imagePopupSrc: ''
    }
  },
  computed: {
    ...mapGetters(['user']),
  },
  methods: {
    featureAllowed(feature) {
      let roles = this.user.instanceUsers.map(item => item.roles).flat()
      return roles.map(item => item.features).flat().some(item => item.id == feature)
    },
    hasFeature(item, feature) {
      if (item.instance_user && item.instance_users && item.instance_users.length) {
        let users = [item.instance_user, ...item.instance_users ]
        let user = users.find(person => this.user.instanceUserIds.includes(person.id))

        return user ? user.roles.map(item => item.features).flat().some(item => item.id == feature) : false
      }
      return false
    },
    canEdit(item) {
      let owner = this.user.instanceUserIds.includes(item.instance_user_id)
      let allowed = item.instance_users ? item.instance_users.find(user => this.user.instanceUserIds.includes(user.id)) : {pivot: {edit: false}}

      return owner || (allowed && allowed.pivot.edit)
    },
    canDelete(item) {
      let owner = this.user.instanceUserIds.includes(item.instance_user_id)
      let allowed = item.instance_users ? item.instance_users.find(user => this.user.instanceUserIds.includes(user.id)) : {pivot: {delete: false}}

      return owner || (allowed && allowed.pivot.delete)
    },
    markDownLinksClick() {
      let markdownBlock = document.getElementsByClassName('markdown')[0]
      if (markdownBlock) {
        markdownBlock.addEventListener("click", (event) => {
          // detect click at links in markdown block
          if (event.target.getAttribute("href") && event.target.getAttribute("href").length) {
            event.preventDefault()
            window.open(event.target.getAttribute("href"))
          }
        })
      }
    },
    getInstanceUserId() {
      let instanceUser = this.user.instanceUsers.find(item => item.user_id == this.user.id)
      return instanceUser ? instanceUser.id : this.user.id
    }
  },
  mounted() {
    this.markDownLinksClick()
  }
})

Vue.filter('getText', (object, field = 'name', defaultText = '') => {
  return object && (typeof object[field] !== "undefined") ? object[field] : defaultText
})
